export const GROUPS = "/auth/Groups"
export const GROUP = "/auth/Group/:param"
